// ИЖС
// садоводство
// фермерское хозяйство
// ДНП
// инвестпроект
// земля промзначения

import suburbanBuildingStatus from './suburban-building-status';

export default suburbanBuildingStatus.filter(sbs => [
    'individualHousingConstruction',
    'gardening',
    'farm',
    'privateFarm',
    'suburbanNonProfitPartnership',
    'investmentProject',
    'industrialLand',
].includes(sbs.key));
